'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var ArrowLeft = function ArrowLeft(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 6 9' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'Path 2'
      ),
      _react2.default.createElement('path', { d: 'M5.122 0L1 4.365l4.122 4.234', stroke: 'currentColor', fill: 'none', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = ArrowLeft;
//# sourceMappingURL=ArrowLeft.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/ArrowLeft.js